import { render, staticRenderFns } from "./bg_animate.vue?vue&type=template&id=2080a94c&scoped=true&"
import script from "./bg_animate.vue?vue&type=script&lang=js&"
export * from "./bg_animate.vue?vue&type=script&lang=js&"
import style0 from "./bg_animate.vue?vue&type=style&index=0&id=2080a94c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2080a94c",
  null
  
)

export default component.exports